import { render, staticRenderFns } from "./SetMailsDialog.vue?vue&type=template&id=96986fb6&scoped=true"
import script from "./SetMailsDialog.vue?vue&type=script&lang=js"
export * from "./SetMailsDialog.vue?vue&type=script&lang=js"
import style0 from "./SetMailsDialog.vue?vue&type=style&index=0&id=96986fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96986fb6",
  null
  
)

export default component.exports